import type { ProcessStoreState } from "./types";

export const state = (): ProcessStoreState => ({
  selectedPlan: undefined,
  promoCodeInfo: undefined,
});
